// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"98bf2bd072cefa1aa440","655":"8d3147f214b2e7274189"}[chunkId] + ".js";
};